import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";

function CrearDocumentoSoporte() {
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [usuario, setUsuario] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [usuarios, setUsuarios] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    const [proveedorId, setProveedorId] = useState('');
    const [nombreProveedor, setNombreProveedor] = useState('');
    const [tipoProveedor, setTipoProveedor] = useState('NIT');
    const [documentoProveedor, setDocumentoProveedor] = useState('');
    const [codigoResponsabilidad, setCodigoResponsabilidad] = useState('No responsable');
    const [codigoRegimen, setCodigoRegimen] = useState('No responsable de IVA');
    const [codigoImpuesto, setCodigoImpuesto] = useState('No causa');
    const [productos, setProductos] = useState([]);
    const [conceptoSeleccionado, setConceptoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    const [conceptosPago, setConceptosPago] = useState([]);
    const [observaciones, setObservaciones] = useState('');
    const [showModalProveedor, setShowModalProveedor] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const proveedoresPorPagina = 10;

    // Modales de confirmación y éxito
    const [showModalConfirmarEgreso, setShowModalConfirmarEgreso] = useState(false);
    const [showModalConfirmarDian, setShowModalConfirmarDian] = useState(false);
    const [showModalExito, setShowModalExito] = useState(false);
    const [documentoIdCreado, setDocumentoIdCreado] = useState(null);
    const [numeroDocumentoCreado, setNumeroDocumentoCreado] = useState('');
    const [egresoGenerado, setEgresoGenerado] = useState(false);
    const [numeroEgresoGenerado, setNumeroEgresoGenerado] = useState('');

    // Modal para mostrar JSON/Errores
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'json', 'error', 'success'

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear documentos soporte
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_documentos_soporte');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/usuarios?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setUsuarios(response.data);
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/parametros-fev?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setParametrosFev(response.data);
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setProveedores(response.data);
            })
            .catch(error => console.log('err: ' + error));

        axios.get('/conceptos-pago?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setConceptosPago(response.data);
            })
            .catch(error => console.log('err: ' + error));
    }, []);

    // Al cambiar el profesional, los prefijos dependen de él: limpiar selección previa
    useEffect(() => {
        setPrefijo('');
        setNumeroDocumento('');
    }, [usuario]);

    const handlePrefijoChange = (e) => {
        const selectedPrefijo = getPrefijosFiltrados().find(p => p.id == e.target.value);
        setPrefijo(e.target.value);
        if (selectedPrefijo) {
            setNumeroDocumento(selectedPrefijo.numero_factura);
        }
    };

    const getPrefijosFiltrados = () => {
        return parametrosFev.filter(param => 
            param.tipo === 'Documento Soporte' && 
            param.users_id == usuario &&
            param.estado == 1
        );
    };

    const agregarConcepto = () => {
        const concepto = conceptosPago.find(c => c.id == conceptoSeleccionado);
        if (concepto) {
            const nuevoProducto = {
                id: Date.now(),
                conceptos_pago_id: concepto.id,
                codigo: concepto.codigo,
                descripcion: concepto.nombre,
                cantidad: 1,
                precio: parseFloat(concepto.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(concepto.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setConceptoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let descuento = 0;
        let iva = 0;
        let pagar = 0;
        
        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            
            // Calcular descuento del producto
            const descuentoProducto = (producto.precio * producto.cantidad) * (producto.porcentaje / 100);
            descuento += descuentoProducto;
            
            // Calcular IVA del producto
            const baseImponible = (producto.precio * producto.cantidad) - descuentoProducto;
            const ivaProducto = baseImponible * (producto.impuesto / 100);
            iva += ivaProducto;
            
            pagar += producto.total;
        });
        
        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const getProveedoresFiltrados = () => {
        if (!busquedaProveedor) return proveedores;
        return proveedores.filter(proveedor => {
            const nombre = proveedor.nombre_proveedor || '';
            const documento = proveedor.numero_documento || '';
            const busqueda = busquedaProveedor.toLowerCase();
            return nombre.toLowerCase().includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getProveedoresPaginados = () => {
        const proveedoresFiltrados = getProveedoresFiltrados();
        const inicio = (paginaActual - 1) * proveedoresPorPagina;
        const fin = inicio + proveedoresPorPagina;
        return proveedoresFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getProveedoresFiltrados().length / proveedoresPorPagina);
    };

    const seleccionarProveedor = (proveedor) => {
        setProveedorId(proveedor.id);
        setNombreProveedor(proveedor.nombre_proveedor);
        setTipoProveedor(proveedor.tipo_documento || 'NIT');
        setDocumentoProveedor(proveedor.numero_documento || '');
        setCodigoResponsabilidad(proveedor.codigo_responsabilidad || 'No responsable');
        setCodigoRegimen(proveedor.codigo_regimen || 'No responsable de IVA');
        setCodigoImpuesto(proveedor.codigo_impuesto || 'No causa');
        setShowModalProveedor(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!proveedorId) {
            alert('Por favor seleccione un proveedor');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un concepto de pago');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const documentoData = {
            uid: userdata.user_id,
            parametrosfev_id: parseInt(prefijo),
            users_id: parseInt(usuario),
            proveedor_id: parseInt(proveedorId),
            fecha_emision: fecha,
            forma_pago: metodoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                conceptos_pago_id: parseInt(producto.conceptos_pago_id),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.post('/documento-soporte', documentoData);
            if (response.status === 200 || response.status === 201) {
                const documentoId = response.data.documento_id;
                const numeroDoc = response.data.numero_documento || documentoId;
                
                // Guardar datos del documento creado
                setDocumentoIdCreado(documentoId);
                setNumeroDocumentoCreado(numeroDoc);
                
                // Mostrar modal para preguntar si quiere generar egreso
                setShowModalConfirmarEgreso(true);
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('Error al guardar el documento soporte: ' + (error.response?.data?.message || error.message));
        }
    };

    // Función para generar egreso
    const generarEgreso = async () => {
        setShowModalConfirmarEgreso(false);
        
        try {
            const egresoResponse = await axios.post('/documento-soporte/generar-egreso', {
                documento_soporte_id: documentoIdCreado
            });
            
            if (egresoResponse.status === 200 || egresoResponse.status === 201) {
                setEgresoGenerado(true);
                setNumeroEgresoGenerado(egresoResponse.data.numero_egreso);
                
                // Mostrar modal para preguntar si quiere enviar a DIAN
                setShowModalConfirmarDian(true);
            }
        } catch (egresoError) {
            console.error('Error al generar egreso:', egresoError);
            alert('Error al generar egreso: ' + (egresoError.response?.data?.message || egresoError.message));
        }
    };

    // Función para no generar egreso y pasar a DIAN
    const noGenerarEgreso = () => {
        setShowModalConfirmarEgreso(false);
        setEgresoGenerado(false);
        
        // Mostrar modal para preguntar si quiere enviar a DIAN
        setShowModalConfirmarDian(true);
    };

    // Función para enviar a DIAN
    const enviarDian = async () => {
        setShowModalConfirmarDian(false);
        
        try {
            const envioResponse = await axios.post(`/documento-soporte/${documentoIdCreado}/enviar-dian`, {});
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Documento soporte enviado exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid,
                    estado: envioResponse.data.estado,
                    documentoId: documentoIdCreado
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code,
                    documentoId: documentoIdCreado
                });
                setShowModalDebug(true);
            }
        } catch (envioError) {
            console.error('Error al enviar a DIAN:', envioError);
            
            // Mostrar modal de error
            setDebugType('error');
            setDebugData({
                message: envioError.response?.data?.message || envioError.message,
                error: envioError.response?.data?.error,
                response: envioError.response?.data?.response,
                json_enviado: envioError.response?.data?.json_enviado,
                fullError: envioError.response?.data,
                documentoId: documentoIdCreado
            });
            setShowModalDebug(true);
        }
        
        // Limpiar formulario
        limpiarFormulario();
    };

    // Función para no enviar a DIAN
    const noEnviarDian = () => {
        setShowModalConfirmarDian(false);
        
        // Mostrar modal de éxito
        setShowModalExito(true);
    };

    // Función para limpiar el formulario
    const limpiarFormulario = () => {
        setProductos([]);
        setProveedorId('');
        setNombreProveedor('');
        setDocumentoProveedor('');
        setObservaciones('');
        setTotalBruto(0);
        setTotalPagar(0);
        setPrefijo('');
        setNumeroDocumento('');
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition doc-soporte-page">
                <style>{`
                    .doc-soporte-page { font-size: 12.5px; }
                    .doc-soporte-page .content-header h1 {
                        font-size: 1.9rem !important;
                        font-weight: 800 !important;
                        margin-bottom: 0 !important;
                    }
                    .doc-soporte-page label {
                        font-size: 0.76rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .doc-soporte-page .form-control {
                        font-size: 0.82rem !important;
                        padding: 0.38rem 0.68rem !important;
                        min-height: 36px;
                    }
                    .doc-soporte-page .btn { font-size: 0.82rem !important; }
                    .ds-soft-card {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.05) !important;
                        box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                    }
                    .ds-soft-header {
                        background: #fff;
                        border-bottom: 1px solid rgba(0,0,0,0.06);
                    }
                    .ds-main-title {
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 1rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .ds-main-title .title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 9px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(23,162,184,0.1);
                        color: #17a2b8;
                        font-size: 0.85rem;
                    }
                    .ds-section-title {
                        margin: 0 0 14px 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 0.95rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .ds-section-title .title-icon {
                        width: 26px;
                        height: 26px;
                        border-radius: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50,58,69,0.08);
                        color: #323a45;
                        font-size: 0.78rem;
                    }
                    .ds-modal .modal-content {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.08) !important;
                        overflow: hidden;
                    }
                    .ds-modal .modal-header.ds-modal-head-neutral {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .ds-modal .modal-header.ds-modal-head-error {
                        background: #f8f9fa !important;
                        border-bottom: 3px solid #dc3545 !important;
                    }
                    .ds-alert-doc-num {
                        border-radius: 12px;
                        border: 1px solid rgba(23, 162, 184, 0.28);
                        background: rgba(23, 162, 184, 0.09);
                        color: #0c5460;
                        padding: 12px 14px;
                        text-align: left;
                    }
                    .ds-alert-cuenta-pagar {
                        border-radius: 12px;
                        border: 1px solid rgba(212, 167, 44, 0.45);
                        background: linear-gradient(180deg, #fffdf8 0%, #fff4d6 100%);
                        color: #6b4f0a;
                        padding: 14px 16px;
                        text-align: left;
                        box-shadow: 0 2px 8px rgba(212, 167, 44, 0.12);
                    }
                    .ds-alert-cuenta-pagar h6 {
                        color: #5c4508;
                        font-weight: 800;
                        margin-bottom: 0;
                    }
                    .ds-alert-cuenta-pagar ul {
                        margin-top: 12px;
                        margin-bottom: 0;
                        padding-left: 1.1rem;
                        font-size: 0.88rem;
                        line-height: 1.45;
                    }
                    .ds-debug-card {
                        border-radius: 12px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        overflow: hidden;
                        box-shadow: 0 4px 14px rgba(0,0,0,0.04) !important;
                    }
                    .ds-debug-card .card-header {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                        color: #323a45 !important;
                        font-weight: 700;
                    }
                    .ds-debug-card-pre {
                        background-color: #f8f9fa;
                        padding: 14px;
                        border-radius: 8px;
                        max-height: 400px;
                        overflow: auto;
                        font-size: 12px;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                        border: 1px solid rgba(0,0,0,0.06);
                    }
                    .ds-alert-soft-success {
                        border-radius: 12px;
                        border: 1px solid rgba(40, 167, 69, 0.32);
                        background: rgba(40, 167, 69, 0.09);
                        color: #155724;
                        padding: 12px 14px;
                        text-align: left;
                    }
                    .ds-alert-soft-danger {
                        border-radius: 12px;
                        border: 1px solid rgba(220, 53, 69, 0.35);
                        background: rgba(220, 53, 69, 0.07);
                        color: #721c24;
                        padding: 12px 14px;
                        text-align: left;
                    }
                    .ds-alert-soft-warn {
                        border-radius: 12px;
                        border: 1px solid rgba(255, 193, 7, 0.4);
                        background: rgba(255, 193, 7, 0.12);
                        color: #856404;
                        padding: 10px 12px;
                        text-align: left;
                    }
                    .factura-lineas-table .factura-col-accion-head,
                    .factura-lineas-table .factura-col-accion-body {
                        width: 44px;
                        min-width: 44px;
                        max-width: 44px;
                        padding: 6px 4px !important;
                        text-align: center;
                        vertical-align: middle !important;
                        white-space: nowrap;
                    }
                    .factura-lineas-table {
                        table-layout: fixed;
                        border-collapse: collapse;
                    }
                    .factura-lineas-table th,
                    .factura-lineas-table td {
                        border: none !important;
                    }
                    .factura-lineas-table thead th {
                        border-bottom: 1px solid #dee2e6 !important;
                        padding-bottom: 8px;
                        font-size: 0.75rem;
                        font-weight: 600;
                        color: #6c757d;
                    }
                    .factura-lineas-table tfoot tr:first-child td {
                        border-top: 1px solid #e9ecef !important;
                        padding-top: 10px;
                    }
                    .factura-lineas-table .factura-col-descripcion {
                        text-align: center;
                        vertical-align: middle;
                        font-size: 0.875rem;
                        padding: 8px 10px;
                        line-height: 1.35;
                        word-break: break-word;
                    }
                    .factura-lineas-table .factura-col-cant,
                    .factura-lineas-table .factura-col-desc {
                        width: 72px;
                        max-width: 72px;
                    }
                    .factura-lineas-table .factura-col-precio {
                        width: 118px;
                        max-width: 118px;
                    }
                    .factura-lineas-table .factura-input-cant,
                    .factura-lineas-table .factura-input-desc {
                        width: 100% !important;
                        max-width: 64px !important;
                        min-width: 0 !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.35rem !important;
                        margin: 0 auto;
                        text-align: center;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-precio {
                        width: 100% !important;
                        max-width: 110px !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.4rem !important;
                        text-align: right;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-cant::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-cant::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                    .factura-total-label-cell {
                        border: none !important;
                        text-align: right;
                        vertical-align: middle !important;
                        padding: 3px 8px !important;
                        font-size: 0.8rem;
                        font-weight: 400;
                        color: #6c757d;
                        white-space: nowrap;
                        min-width: 96px;
                        line-height: 1.25;
                    }
                    .factura-total-value-cell {
                        border: none !important;
                        padding: 3px 0 !important;
                        vertical-align: middle !important;
                    }
                    .factura-total-value-input {
                        width: 100%;
                        max-width: 100%;
                        text-align: right;
                        font-size: 0.85rem;
                        font-weight: 400;
                        color: #495057;
                        background-color: #f8f9fa !important;
                        padding: 0.28rem 0.4rem !important;
                        min-height: 30px !important;
                    }
                    .factura-total-value-input.factura-total-final {
                        font-size: 0.9rem;
                        font-weight: 600;
                        color: #17a2b8;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-documentos-soporte">Listado de Documentos Soporte</Link></li>
                                        <li className="breadcrumb-item active">Crear Documento Soporte</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Documento Soporte</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card card-info card-outline ds-soft-card">
                                <div className="card-header ds-soft-header">
                                    <h5 className="ds-main-title">
                                        <span className="title-icon"><i className="fas fa-file-invoice"></i></span>
                                        Información del Documento Soporte
                                    </h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        
                                        <h5 className="ds-section-title">
                                            <span className="title-icon"><i className="fas fa-truck"></i></span>
                                            Información del Proveedor
                                        </h5>
                                        
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Nombre *</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={nombreProveedor}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>Tipo *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={tipoProveedor}
                                                        disabled
                                                        required
                                                    >
                                                        <option value="NIT">NIT</option>
                                                        <option value="CC">CC</option>
                                                        <option value="CE">CE</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>N° Documento *</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={documentoProveedor}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-info form-control"
                                                        onClick={() => setShowModalProveedor(true)}
                                                    >
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Responsabilidad *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={codigoResponsabilidad}
                                                        onChange={(e) => setCodigoResponsabilidad(e.target.value)}
                                                        required
                                                    >
                                                        <option>No responsable</option>
                                                        <option>Régimen simple de tributación</option>
                                                        <option>Gran contribuyente</option>
                                                        <option>Autorretenedor</option>
                                                        <option>Agente de retención IVA</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Tipo de Régimen *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={codigoRegimen}
                                                        onChange={(e) => setCodigoRegimen(e.target.value)}
                                                        required
                                                    >
                                                        <option>No responsable de IVA</option>
                                                        <option>Impuesto sobre las ventas / IVA</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Impuesto *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={codigoImpuesto}
                                                        onChange={(e) => setCodigoImpuesto(e.target.value)}
                                                        required
                                                    >
                                                        <option>No causa</option>
                                                        <option>IVA</option>
                                                        <option>INC</option>
                                                        <option>IVA e INC</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <hr />

                                        <h5 className="ds-section-title">
                                            <span className="title-icon"><i className="fas fa-file-alt"></i></span>
                                            Datos del Documento
                                        </h5>

                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Fecha Emisión *</label>
                                                    <input 
                                                        type="date" 
                                                        className="form-control" 
                                                        value={fecha}
                                                        onChange={(e) => setFecha(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Método de Pago *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={metodoPago}
                                                        onChange={(e) => setMetodoPago(e.target.value)}
                                                        required
                                                    >
                                                        <option value="10">Efectivo</option>
                                                        <option value="42">Consignación bancaria</option>
                                                        <option value="48">Tarjeta Crédito</option>
                                                        <option value="49">Tarjeta Débito</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Profesional que emite *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={usuario}
                                                        onChange={(e) => setUsuario(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Seleccionar profesional...</option>
                                                        {usuarios.map(u => (
                                                            <option key={u.id} value={u.id}>{u.name} {u.lastname}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Prefijo *</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={prefijo}
                                                        onChange={handlePrefijoChange}
                                                        required
                                                        disabled={!usuario}
                                                    >
                                                        <option value="">{usuario ? 'Seleccionar prefijo...' : 'Primero elija al profesional'}</option>
                                                        {getPrefijosFiltrados().map(p => (
                                                            <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>N° Documento *</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={numeroDocumento}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <hr />

                                        <h5 className="ds-section-title">
                                            <span className="title-icon"><i className="fas fa-list-ul"></i></span>
                                            Conceptos de Pago
                                        </h5>

                                        <div className="row">
                                            <div className="col-md-10">
                                                <div className="form-group">
                                                    <label>Selecciona el Concepto</label>
                                                    <select 
                                                        className="form-control" 
                                                        value={conceptoSeleccionado}
                                                        onChange={(e) => setConceptoSeleccionado(e.target.value)}
                                                    >
                                                        <option value="">Seleccionar...</option>
                                                        {conceptosPago.map(concepto => (
                                                            <option key={concepto.id} value={concepto.id}>
                                                                {concepto.codigo} - {concepto.nombre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-info form-control"
                                                        onClick={agregarConcepto}
                                                    >
                                                        Agregar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                            <table className="table factura-lineas-table" style={{ minWidth: '960px' }}>
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" style={{ width: '10%', minWidth: '88px' }}>Código</th>
                                                        <th className="text-center factura-col-descripcion">Descripción</th>
                                                        <th className="text-center factura-col-cant">Cant.</th>
                                                        <th className="text-center factura-col-precio">Precio</th>
                                                        <th className="text-center factura-col-desc">Desc %</th>
                                                        <th className="text-center" style={{ width: '7%', minWidth: '72px' }}>IVA %</th>
                                                        <th className="text-center" style={{ width: '14%', minWidth: '120px' }}>Total</th>
                                                        <th className="text-center factura-col-accion-head"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {productos.map(producto => (
                                                        <tr key={producto.id}>
                                                            <td className="text-center">{producto.codigo}</td>
                                                            <td className="factura-col-descripcion">{producto.descripcion}</td>
                                                            <td className="text-center factura-col-cant">
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm factura-input-cant" 
                                                                    value={producto.cantidad}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                    min="1"
                                                                />
                                                            </td>
                                                            <td className="text-right factura-col-precio">
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm factura-input-precio" 
                                                                    value={producto.precio}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                    step="0.01"
                                                                />
                                                            </td>
                                                            <td className="text-center factura-col-desc">
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm factura-input-desc" 
                                                                    value={producto.porcentaje}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                    min="0"
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input 
                                                                    type="number" 
                                                                    className="form-control form-control-sm factura-input-desc" 
                                                                    value={producto.impuesto}
                                                                    onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                    min="0"
                                                                />
                                                            </td>
                                                            <td className="text-right">
                                                                $ {parseFloat(producto.total || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </td>
                                                            <td className="factura-col-accion-body">
                                                                <button 
                                                                    type="button" 
                                                                    className="btn p-0 border-0 bg-transparent text-danger"
                                                                    onClick={() => eliminarProducto(producto.id)}
                                                                    title="Eliminar concepto"
                                                                >
                                                                    <i className="fas fa-trash-alt"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="5" style={{ border: 'none' }}></td>
                                                        <td className="factura-total-label-cell">Subtotal:</td>
                                                        <td className="factura-total-value-cell">
                                                            <input 
                                                                type="text" 
                                                                className="form-control form-control-sm factura-total-value-input" 
                                                                value={'$ ' + parseFloat(totalBruto || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ border: 'none' }}></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="5" style={{ border: 'none' }}></td>
                                                        <td className="factura-total-label-cell">Descuento{'\u00A0'}:</td>
                                                        <td className="factura-total-value-cell">
                                                            <input 
                                                                type="text" 
                                                                className="form-control form-control-sm factura-total-value-input" 
                                                                value={'$ ' + parseFloat(0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ border: 'none' }}></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="5" style={{ border: 'none' }}></td>
                                                        <td className="factura-total-label-cell">IVA:</td>
                                                        <td className="factura-total-value-cell">
                                                            <input 
                                                                type="text" 
                                                                className="form-control form-control-sm factura-total-value-input" 
                                                                value={'$ ' + parseFloat(0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ border: 'none' }}></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="5" style={{ border: 'none' }}></td>
                                                        <td className="factura-total-label-cell">Total:</td>
                                                        <td className="factura-total-value-cell">
                                                            <input 
                                                                type="text" 
                                                                className="form-control form-control-sm factura-total-value-input factura-total-final" 
                                                                value={'$ ' + parseFloat(totalPagar || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ border: 'none' }}></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        <hr />

                                        <div className="form-group">
                                            <label>Observaciones</label>
                                            <textarea 
                                                className="form-control" 
                                                rows="3"
                                                value={observaciones}
                                                onChange={(e) => setObservaciones(e.target.value)}
                                                placeholder="Observaciones del documento..."
                                            ></textarea>
                                        </div>

                                        <div className="form-group">
                                            <button type="submit" className="btn btn-info mr-2">
                                                <i className="fas fa-save"></i> Guardar Documento Soporte
                                            </button>
                                            <Link to="/listado-documentos-soporte" className="btn btn-secondary">
                                                <i className="fas fa-arrow-left"></i> Cancelar
                                            </Link>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {showModalProveedor && (
                    <div className="modal fade show ds-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0">
                                <div className="modal-header ds-modal-head-neutral">
                                    <h5 className="modal-title text-dark font-weight-bold mb-0">
                                        <i className="fas fa-truck mr-2 text-info"></i>
                                        Seleccionar Proveedor
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalProveedor(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaProveedor}
                                            onChange={(e) => {
                                                setBusquedaProveedor(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getProveedoresPaginados().map((proveedor, index) => (
                                                    <tr key={index}>
                                                        <td>{proveedor.nombre_proveedor}</td>
                                                        <td>{proveedor.numero_documento}</td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarProveedor(proveedor)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalProveedor(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Confirmar Egreso */}
                <Modal
                    show={showModalConfirmarEgreso}
                    onHide={() => setShowModalConfirmarEgreso(false)}
                    centered
                    dialogClassName="ds-modal"
                    contentClassName="border-0"
                >
                    <Modal.Header closeButton className="ds-modal-head-neutral border-bottom">
                        <Modal.Title className="h6 text-dark font-weight-bold mb-0">
                            <i className="fas fa-file-invoice mr-2 text-info"></i>
                            Documento guardado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        <div className="mb-4">
                            <span
                                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                    width: 72,
                                    height: 72,
                                    background: 'rgba(23, 162, 184, 0.12)',
                                    color: '#17a2b8'
                                }}
                            >
                                <i className="fas fa-check" style={{ fontSize: '2rem' }}></i>
                            </span>
                        </div>
                        <h5 className="mb-3 text-dark" style={{ fontWeight: 700 }}>Documento soporte guardado correctamente</h5>
                        <div className="ds-alert-doc-num mb-3">
                            <strong>Número de documento:</strong> {numeroDocumentoCreado}
                        </div>
                        <div className="ds-alert-cuenta-pagar">
                            <h6 className="mb-0">¿Desea generar un egreso para cancelar esta cuenta por pagar?</h6>
                            <ul className="text-left mt-3">
                                <li><strong>Sí:</strong> se creará un egreso automáticamente y se marcará como pagada.</li>
                                <li><strong>No:</strong> quedará registrada como cuenta por pagar para gestionar después.</li>
                            </ul>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center flex-wrap border-top bg-light" style={{ gap: '10px' }}>
                        <Button
                            variant="info"
                            onClick={generarEgreso}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-money-bill-wave mr-2"></i>
                            Sí, generar egreso
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={noGenerarEgreso}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-clock mr-2"></i>
                            No, dejar pendiente
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Confirmar Envío a DIAN */}
                <Modal
                    show={showModalConfirmarDian}
                    onHide={() => setShowModalConfirmarDian(false)}
                    centered
                    dialogClassName="ds-modal"
                    contentClassName="border-0"
                >
                    <Modal.Header closeButton className="ds-modal-head-neutral border-bottom">
                        <Modal.Title className="h6 text-dark font-weight-bold mb-0">
                            <i className="fas fa-paper-plane mr-2 text-info"></i>
                            Enviar a la DIAN
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        {egresoGenerado && (
                            <div className="ds-alert-soft-success mb-3 text-left">
                                <i className="fas fa-check-circle mr-2 text-success"></i>
                                Egreso N° <strong>{numeroEgresoGenerado}</strong> generado correctamente.
                            </div>
                        )}
                        <h5 className="mb-3 text-dark" style={{ fontWeight: 700 }}>¿Desea enviar el documento a la DIAN?</h5>
                        <p className="text-muted mb-0">
                            El documento se transmitirá electrónicamente para su validación y registro oficial.
                        </p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center flex-wrap border-top bg-light" style={{ gap: '10px' }}>
                        <Button
                            variant="info"
                            onClick={enviarDian}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-paper-plane mr-2"></i>
                            Sí, enviar
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={noEnviarDian}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-times mr-2"></i>
                            No enviar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Éxito Final */}
                <Modal
                    show={showModalExito}
                    onHide={() => setShowModalExito(false)}
                    centered
                    dialogClassName="ds-modal"
                    contentClassName="border-0"
                >
                    <Modal.Header closeButton className="ds-modal-head-neutral border-bottom">
                        <Modal.Title className="h6 text-dark font-weight-bold mb-0">
                            <i className="fas fa-check-circle mr-2 text-info"></i>
                            Proceso completado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        <div className="mb-4">
                            <span
                                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                    width: 72,
                                    height: 72,
                                    background: 'rgba(23, 162, 184, 0.12)',
                                    color: '#17a2b8'
                                }}
                            >
                                <i className="fas fa-file-alt" style={{ fontSize: '2rem' }}></i>
                            </span>
                        </div>
                        <h5 className="mb-3 text-dark" style={{ fontWeight: 700 }}>Documento guardado correctamente</h5>
                        <div className="ds-alert-doc-num mb-3">
                            <strong>Número de documento:</strong> {numeroDocumentoCreado}
                        </div>
                        {egresoGenerado && (
                            <div className="ds-alert-soft-success mb-3">
                                <strong>Egreso generado:</strong> N° {numeroEgresoGenerado}
                            </div>
                        )}
                        <p className="text-muted mb-0">
                            {egresoGenerado
                                ? 'El documento ha sido marcado como pagada.'
                                : 'El documento quedó registrado como cuenta por pagar.'}
                        </p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center flex-wrap border-top bg-light" style={{ gap: '10px' }}>
                        <Button
                            variant="info"
                            onClick={() => {
                                setShowModalExito(false);
                                history.push(`/informacion-documento-soporte/${documentoIdCreado}`);
                            }}
                            style={{ minWidth: '150px' }}
                        >
                            <i className="fas fa-eye mr-2"></i>
                            Ver información
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShowModalExito(false);
                                history.push('/listado-documentos-soporte');
                            }}
                            style={{ minWidth: '150px' }}
                        >
                            <i className="fas fa-list mr-2"></i>
                            Ir al listado
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Debug - Mostrar JSON/Errores */}
                {showModalDebug && (
                    <div className="modal fade show ds-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content border-0">
                                <div className={`modal-header ${debugType === 'success' ? 'ds-modal-head-neutral' : 'ds-modal-head-error'}`}>
                                    <h5 className="modal-title text-dark font-weight-bold mb-0">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2 text-info"></i>Envío exitoso</>
                                        ) : (
                                            <><i className="fas fa-exclamation-triangle mr-2 text-danger"></i>Error en el envío</>
                                        )}
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalDebug(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="ds-alert-doc-num mb-3">
                                                <h6 className="mb-0 font-weight-bold"><i className="fas fa-check-circle mr-2"></i>{debugData?.message}</h6>
                                            </div>
                                            <div className="card ds-debug-card mb-0">
                                                <div className="card-header">
                                                    <strong><i className="fas fa-info-circle mr-2 text-info"></i>Detalles de la respuesta</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p className="mb-2"><strong>CUFE:</strong> <code style={{ fontSize: '0.9em' }}>{debugData?.cufe}</code></p>
                                                    <p className="mb-0"><strong>Estado del documento:</strong>
                                                        <span className="badge badge-info ml-2">Enviado a DIAN</span>
                                                    </p>
                                                </div>
                                            </div>
                                            {debugData?.documentoId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => { window.location.href = '/#/listado-documentos-soporte'; }}
                                                    >
                                                        <i className="fas fa-list mr-1"></i> Ir al listado
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="ds-alert-soft-danger mb-3">
                                                <h6 className="mb-0 font-weight-bold"><i className="fas fa-exclamation-triangle mr-2"></i>{debugData?.message}</h6>
                                            </div>

                                            {debugData?.response && (
                                                <div className="card ds-debug-card mb-3">
                                                    <div className="card-header">
                                                        <strong><i className="fas fa-exclamation-triangle mr-2 text-warning"></i>Respuesta de la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre className="ds-debug-card-pre mb-0">{JSON.stringify(debugData.response, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}

                                            {debugData?.json_enviado && (
                                                <div className="card ds-debug-card mb-3">
                                                    <div className="card-header">
                                                        <strong><i className="fas fa-code mr-2 text-info"></i>JSON enviado a la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre className="ds-debug-card-pre mb-0">{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}

                                            {debugData?.status_code && (
                                                <div className="ds-alert-soft-warn mb-0">
                                                    <strong>Código de estado HTTP:</strong> {debugData.status_code}
                                                </div>
                                            )}

                                            {debugData?.documentoId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => { window.location.href = '/#/listado-documentos-soporte'; }}
                                                    >
                                                        <i className="fas fa-list mr-1"></i> Ir al listado
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default CrearDocumentoSoporte;
